export enum ChartOption {
  Chart = "chartOptions",
  MosaicChart = "mosaicChartOptions",

  XAxis = "xAxisOptions",
  XAxisCategory = "xAxisCategoryOptions",
  YAxis = "yAxisOptions",
  Tooltip = "tooltipOptions",
  Title = "titleOptions",

  LineSeries = "lineOptions",
  Bar = "barOptions",
  Box = "boxOptions",
  Pie = "pieOptions",
  ScatterSeries = "scatterOptions",
  MosaicSeries = "mosaicSeriesOptions"
}
